export const ADVERTISER_DOMAIN_REPORT_ID = 'advertiser-domain';
